import { trackMoveAction } from '../../_common/client/tracking';

export const addMoveTrackingToStarAmountLink = (link: HTMLElement) => {
    const numOfStars = link.getAttribute('data-num-of-stars');
    if (numOfStars == null) {
        console.error('Could not determine number of stars for tracking in star filter');
        return;
    }
    link.addEventListener('click', () => {
        trackMoveAction(
            {
                ot_PageCluster: ['Artikeldetailseite'],
                review_FilterReview: ['select'],
                review_FilterReviewStars: [numOfStars],
                review_Navigation: ['star sorted'],
            },
            { name: 'click', features: [] }
        );
    });
};
